import { render, staticRenderFns } from "./form-partial-delivery-truck.vue?vue&type=template&id=68b2c13e"
import script from "./form-partial-delivery-truck.vue?vue&type=script&lang=js"
export * from "./form-partial-delivery-truck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports